<script lang="ts">
	import * as m from '$lib/paraglide/messages.js';
	import * as Table from '$lib/components/ui/table/index.js';
	import { getLocale } from '@/paraglide/runtime';

	const locale = $derived(getLocale());

	const rows = $derived.by(() => {
		void locale;
		return [
			{
				title: m.marketplace_seo_license_row_none_title(),
				boats: m.marketplace_seo_license_row_none_boats(),
				scope: m.marketplace_seo_license_row_none_scope()
			},
			{
				title: m.marketplace_seo_license_row_ln_title(),
				boats: m.marketplace_seo_license_row_ln_boats(),
				scope: m.marketplace_seo_license_row_ln_scope()
			},
			{
				title: m.marketplace_seo_license_row_pnb_title(),
				boats: m.marketplace_seo_license_row_pnb_boats(),
				scope: m.marketplace_seo_license_row_pnb_scope()
			},
			{
				title: m.marketplace_seo_license_row_per_title(),
				boats: m.marketplace_seo_license_row_per_boats(),
				scope: m.marketplace_seo_license_row_per_scope()
			},
			{
				title: m.marketplace_seo_license_row_py_title(),
				boats: m.marketplace_seo_license_row_py_boats(),
				scope: m.marketplace_seo_license_row_py_scope()
			},
			{
				title: m.marketplace_seo_license_row_cy_title(),
				boats: m.marketplace_seo_license_row_cy_boats(),
				scope: m.marketplace_seo_license_row_cy_scope()
			}
		];
	});

	const colTitle = $derived.by(() => {
		void locale;
		return m.marketplace_seo_license_table_col_title();
	});
	const colBoats = $derived.by(() => {
		void locale;
		return m.marketplace_seo_license_table_col_boats();
	});
	const colScope = $derived.by(() => {
		void locale;
		return m.marketplace_seo_license_table_col_scope();
	});
</script>

<div class="-mx-1 overflow-x-auto">
	<Table.Root class="min-w-[540px] text-sm">
		<Table.Header>
			<Table.Row>
				<Table.Head class="w-[28%] whitespace-normal">{colTitle}</Table.Head>
				<Table.Head class="w-[32%] whitespace-normal">{colBoats}</Table.Head>
				<Table.Head class="whitespace-normal">{colScope}</Table.Head>
			</Table.Row>
		</Table.Header>
		<Table.Body>
			{#each rows as row (row.title)}
				<Table.Row>
					<Table.Cell class="align-top font-medium text-foreground">{row.title}</Table.Cell>
					<Table.Cell class="align-top text-muted-foreground">{row.boats}</Table.Cell>
					<Table.Cell class="align-top text-muted-foreground">{row.scope}</Table.Cell>
				</Table.Row>
			{/each}
		</Table.Body>
	</Table.Root>
</div>
